export const IS_PRODUCTION = process.env.NODE_ENV === 'production';
export const PROJECT_TITLE = process.env.PROJECT_NAME || '';
export const API_URL = process.env.API_URL || '';
export const CRM_URL = process.env.CRM_URL || '';
export const AUTOCALLER_URL = process.env.AUTOCALLER_URL || '';
export const SMS_MODULE_URL = process.env.SMS_MODULE_URL || '';
export const NOTIFY_SOCKET_IO = process.env.NOTIFY_SOCKET_IO || '';
export const NOTIFY_SOCKET_WS = process.env.NOTIFY_SOCKET_WS || '';
export const HLR_URL = process.env.HLR_URL || '';
export const AMO_URL = process.env.AMO_URL || '';
export const RECAPTCHA_SITE_KEY = process.env.RECAPTCHA_SITE_KEY || '';
export const SECRET_KEY = process.env.SECRET_KEY || '';